<template>
    <div class="edit app-inner">
         <div class="public-btn-small flex align-cen posta" style="padding-left:0;left:200px;width:calc(100% - 200px)">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
            
             <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
            @click="onSubmit('ruleForm')"
            >
                修改
            </el-button>
            </div>
              <div class="edit-from">
                  <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
         <el-form ref="ruleForm" :model="form" label-width="100px" :rules="rules" class="flex align-cen">
             <el-form-item label="团队名称：" prop="name">
                    <el-input v-model="form.name" placeholder="请输入企业名称【0-50】" clearable></el-input>
                </el-form-item>
                 <el-form-item label="企业税号：">
                    <el-input v-model="form.taxId" placeholder="请输入企业税号" clearable></el-input>
                </el-form-item>
                 <el-form-item label="团队电话：" prop="phone">
                    <el-input v-model="form.phone" placeholder="请输入团队电话" clearable></el-input>
                </el-form-item>
                        <el-form-item label="团队全称：">
                    <el-input v-model="form.fullName" placeholder="请输入团队全称" clearable></el-input>
                </el-form-item>
                   <el-form-item label="详细地址：" prop="province">
                    <el-cascader
                            size="large"
                            :options="options1"
                            v-model="selectedOptions"
                            @change="handleChange"
                            placeholder="请选择省/市/区"
                            clearable
                            >
                     </el-cascader>
                    <el-input v-model="form.address" placeholder="请输入详细地址【必填】" clearable style="margin-top:20px"></el-input>
                </el-form-item>
                        <el-form-item label="团队LOGO：">
                    <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :disabled="uploadBoolean"
                    :before-upload="$util.beforeUpload"
                    :on-error="upLoadError"
                    >
                    <img :src="form.logo" class="avatar" v-if="form.logo">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">120*40</span></div>
                       <!--页面新增删除和预览-->
                    <span v-if="form.logo" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </span>
                    <el-dialog :visible.sync="oploadDialogVisible" size="tiny" :modal-append-to-body="false" :show-close="false">
                        <img width="100%" :src="form.logo" alt="">
                    </el-dialog>
                    </el-upload>
                 </el-form-item>
         </el-form>
              </div>
    </div>
</template>
<script>
import { getBusiness, editBusiness} from "@/api/enterprise/index"; // 团队详情、修改团队信息
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
import  Format from "../../../../utils/auth.js"  
export default {
    name:'busInessDetail',
    data () {
        return {
            uploadBoolean:false,
            oploadDialogVisible:false,
            headers:{},
             alladdress:'',
            options1: regionData,
            selectedOptions: [],
            loading:false,
            businessInfo:{},
            form:{
                name:'',
                classifyId:'',
                phone:'',
                webSite:'',
                 province:'',
                city:'',
                district:'',
                address:'',
                logo:'',
                taxId:'',
                fullName:''
            },
            rules:{
                 name: [
                     {
                        validator: Format.FormValidate.Form().APPName,   //validator： 自定义验证规则
                        trigger: "blur",
                        message:'请正确输入符合规则的团队名称',
                        required: true, 
                        }
                 ],
                  phone:[
                  {
                        validator: Format.FormValidate.Form().Phone,   //validator： 自定义验证规则
                        trigger: "blur",
                        message:'请输入正确号码!',
                        required: true, 
                        }
              ],
              province: [{ required: true, message: '请选择地址', trigger: 'change' },],
            }
        }
    },
    created () {
         let token = this.$locaStorage.setAge().get('token1')
        this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.getDetail()
         if(token){
            this.headers = {
                'Authorization': token
            }
        }
    },
    methods: {
          // 图片放大
         oploadImgPre(){
                this.oploadDialogVisible = true
            },
             oploadImgDel(){
                this.form.logo = ''
                let _this= this
                setTimeout(function(){
                    _this.uploadBoolean = false
                },1000)
            },
          handleAvatarSuccess(res, file) {
        this.form.logo = res.data.url
        
        if(this.form.logo){
        this.uploadBoolean = true
         }
      },
      // 图片上传失败钩子
      upLoadError(err){
        this.$message.error('图片上传失败')
      },
              handleChange (value) {
        if (value[1] != null && value[2] != null) {
        this.form.province = CodeToText[value[0]]
        this.form.city = CodeToText[value[1]]
        this.form.district = CodeToText[value[2]]
        this.alladdress = CodeToText[value[0]] +'-' + CodeToText[value[1]] + '-' + CodeToText[value[2]]
      } else {
        if (value[1] != null) {
             this.form.province = CodeToText[value[0]]
        this.form.city = CodeToText[value[1]]
         this.alladdress = CodeToText[value[0]] + '-' + CodeToText[value[1]]
        } else {
             this.form.province = CodeToText[value[0]]
          this.alladdress = CodeToText[value[0]]
        }
      }
      },
           // 获取详情
        getDetail(){
             getBusiness({
                id:this.businessInfo.id
              },'enterprise')
            .then(res => {
               this.form = {
                 name:res.data.name,
                 classifyId:res.data.classifyId,
                 phone:res.data.phone, 
                 webSite:res.data.webSite,
                 province:res.data.province,
                 city:res.data.city,
                 district:res.data.district,
                 address:res.data.address,
                 logo:res.data.logo,
                taxId:res.data.taxId,
                fullName:res.data.fullName
               }
               this.selectedOptions = [TextToCode[res.data.province].code, TextToCode[res.data.province][res.data.city].code, TextToCode[res.data.province][res.data.city][res.data.district].code]
            })
        },
        // 返回
        reback(){
            this.$router.push('/webenterpriseManage/teamSet')
        },
        // 修改
        onSubmit(formName){
            let params = { ...this.form};
            params = {...this.form,id:this.businessInfo.id}; 
            this.$refs[formName].validate((valid) => {
                if(valid){
                    this.loading = true
                     editBusiness(params,'enterprise')
                        .then(res => {
                          this.loading = false
                           if(res.code == 0){
                           this.$message.success('修改成功');
                                setTimeout(() => {
                           this.$router.push("/webenterpriseManage/teamSet")
                             }, 100);
                           }else{
                            this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
                           this.loading = false
                        })
                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.edit{
    height: inherit;
    .edit-header{
        border-bottom: 1px solid #ccc;
        border-top: 1px solid #ccc;
        padding: 20px;

    }
    .edit-from{
       margin-bottom: 44px;
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
         .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        }
         }
         .businessList-filter-list{
            .label::before{
                content: '*';
                color: red;
            }
         }

    }
}
  ::v-deep{
 .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  
  .avatar {
    width: 80px;
    height: 80px;
    display: block;
  }
  .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
    }
   .upload-icon {
        position: absolute;
        top: 50%;
        margin-left: -28px;
        margin-top: -18px;
    }
    .el-dialog{
        width: 30%;
    }
  }
</style>